// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
/// <reference path="../../typings/coveo-search-ui/CoveoJsSearch.d.ts"/>
var Coveo = require("coveo-search-ui");
var Logger_1 = require("./Logger");
var DefaultSortHandler_1 = require("./Sorts/DefaultSortHandler");
var ExpressionsHelper_1 = require("./Rules/ExpressionsHelper");
var SearchEndpointHelper_1 = require("./SearchEndpointHelper");
var OmniboxResultListHandler_1 = require("./OmniboxResultList/OmniboxResultListHandler");
var SitecoreAnalyticsHandler_1 = require("./Analytics/SitecoreAnalyticsHandler");
var CoveoForSitecoreBase = (function () {
    function CoveoForSitecoreBase(searchComponent, options, defaultOptions) {
        this.isInPageEditorCssClass = "coveo-page-editor";
        this.isEditingInPageEditorCssClass = "coveo-page-editor-editing";
        this.isPreviewingInPageEditorCssClass = "coveo-page-editor-previewing";
        this.isPreviewingInPageEditorWithSimulatedDeviceCssClass = "coveo-page-editor-previewing-with-simulator";
        this.element = searchComponent;
        this.domElement = Coveo.$$(searchComponent);
        this.options = _.extend({}, defaultOptions, options);
        this.logger = new Logger_1["default"](this.options.enableClientSideLogging);
        this.expressionsHelper = new ExpressionsHelper_1["default"]();
        this.omniboxResultListHandler = new OmniboxResultListHandler_1["default"]();
        this.sitecoreAnalyticsHandler = new SitecoreAnalyticsHandler_1["default"](this.options);
        this.defaultSortHandler = new DefaultSortHandler_1["default"](options);
        this.context = {};
    }
    CoveoForSitecoreBase.prototype.initialize = function () {
        var _this = this;
        this.logger.log("Initializing search.");
        this.initializeSearchOptions();
        if (!this.options.isInitialized) {
            this.addPageEditorCssClasses();
            this.addResultListHeaderCssClasses();
            this.domElement.on(Coveo.InitializationEvents.afterInitialization, function () {
                _this.trySetOriginContextInUsageAnalytics();
                if (!Coveo.HashUtils.getValue("sort", window.location.hash)) {
                    Coveo.state(_this.element, "sort", _this.options.defaultSortCriteriaLowercase);
                }
            });
            // Merge the options we need to add with the options that are already set.
            var mergedOptions = Coveo.Utils.extendDeep({
                Facet: {},
                SearchInterface: {}
            }, this.options);
            Coveo.init(this.element, mergedOptions);
        }
        this.doPostInitializationActions();
    };
    CoveoForSitecoreBase.prototype.doPostInitializationActions = function () {
        var _this = this;
        _.forEach(this.domElement.findAll(".CoveoQuerybox input, .CoveoOmnibox input"), function (element) {
            element.setAttribute("placeholder", _this.options.searchboxPlaceholderText);
        });
    };
    CoveoForSitecoreBase.prototype.initializeSearchOptions = function () {
        var _this = this;
        SearchEndpointHelper_1["default"].initializeEndpoint(this.options);
        if (this.options.enableClientSideLogging) {
            Coveo.Logger.enable();
        }
        if (!this.options.isInitialized) {
            this.addPageEditorCssClasses();
            this.domElement.on(Coveo.QueryEvents.buildingQuery, function (e, args) {
                _this.defaultSortHandler.addSortCriteriaToQuery(args.queryBuilder);
                _this.addContextToQuery(args.queryBuilder);
            });
            this.domElement.on(Coveo.InitializationEvents.afterInitialization, function () {
                _this.registerSearchEvents();
                _this.options.isInitialized = true;
            });
            if (this.options.sendToSitecoreAnalytics) {
                this.sitecoreAnalyticsHandler.registerSitecoreAnalytics(this.domElement);
            }
        }
    };
    CoveoForSitecoreBase.prototype.postAnalytics = function (eventAction, eventType, eventData) {
        this.sitecoreAnalyticsHandler.postAnalytics(eventAction, eventType, eventData);
    };
    CoveoForSitecoreBase.prototype.addPageEditorCssClasses = function () {
        if (this.isInPageEditor()) {
            this.domElement.addClass(this.isInPageEditorCssClass);
            if (this.options.isEditingInPageEditor) {
                this.domElement.addClass(this.isEditingInPageEditorCssClass);
            }
            if (this.options.isPreviewingInPageEditor) {
                this.domElement.addClass(this.isPreviewingInPageEditorCssClass);
            }
            if (this.options.isPreviewingInPageEditorWithSimulatedDevice) {
                this.domElement.addClass(this.isPreviewingInPageEditorWithSimulatedDeviceCssClass);
            }
        }
    };
    CoveoForSitecoreBase.prototype.addResultListHeaderCssClasses = function () {
        // Both the mobile and full search interface does not use the
        // same CSS class for the result list header.
        var elements = this.getDomElementsMatchingSelector(".coveo-results-header, .coveo-result-header-section");
        _.filter(elements, function (element) {
            return typeof (element) !== "undefined" &&
                !element.hasClass("CoveoQuerySummary") &&
                element.hasClass("CoveoQueryDuration") &&
                element.hasClass("CoveoSort");
        }).forEach(function (element) {
            element.addClass("coveo-empty");
        });
    };
    CoveoForSitecoreBase.prototype.getFilterExpressions = function () {
        return this.expressionsHelper.getFilterExpression(this.options);
    };
    CoveoForSitecoreBase.prototype.registerSearchEvents = function () {
        var _this = this;
        this.logger.log("Registering search events.");
        this.domElement.on(Coveo.QueryEvents.buildingQuery, function (e, args) {
            var optionsWithTabContent = _this.getOptionsWithTabExternalContent(args.queryBuilder.tab);
            args.queryBuilder.advancedExpression.add(_this.expressionsHelper.getSearchExpression(optionsWithTabContent));
            args.queryBuilder.constantExpression.add(_this.expressionsHelper.getFilterExpression(optionsWithTabContent));
        });
        this.domElement.on(Coveo.AnalyticsEvents.changeAnalyticsCustomData, function (e, args) {
            var options = _this.options;
            if (options) {
                if (options.scOverrideCurrentLanguage && !!options.clientLanguageName) {
                    args.language = options.clientLanguageName;
                }
                if (options.scOverrideOriginWithPageName && !!options.pageName) {
                    args.originLevel1 = options.pageName;
                }
                if (options.analyticsCustomMetadata) {
                    _.extend(args.metaObject, options.analyticsCustomMetadata);
                }
                if (options.userContext) {
                    for (var key in options.userContext) {
                        _.extend(args.metaObject, (_a = {},
                            _a["context_" + key] = options.userContext[key],
                            _a
                        ));
                    }
                }
            }
            var _a;
        });
        if (this.options.componentRefreshCallback) {
            this.domElement.on(Coveo.QueryEvents.deferredQuerySuccess, function () {
                _this.options.componentRefreshCallback();
            });
            this.domElement.on(Coveo.QueryEvents.queryError, function () {
                _this.options.componentRefreshCallback();
            });
        }
    };
    CoveoForSitecoreBase.prototype.isInPageEditor = function () {
        return this.options.isEditingInPageEditor ||
            this.options.isPreviewingInPageEditor ||
            this.options.isPreviewingInPageEditorWithSimulatedDevice;
    };
    CoveoForSitecoreBase.prototype.configureOmnibox = function (options) {
        this.domElement.on(Coveo.OmniboxEvents.populateOmnibox, this.generatePopulateOmniboxFunction(options));
    };
    CoveoForSitecoreBase.prototype.trySetOriginContextInUsageAnalytics = function () {
        var searchInterfaceComponent = Coveo.get(this.domElement.el, Coveo.SearchInterface, true);
        if (searchInterfaceComponent && searchInterfaceComponent.usageAnalytics) {
            searchInterfaceComponent.usageAnalytics.setOriginContext("WebsiteSearch");
        }
    };
    CoveoForSitecoreBase.prototype.addContextToQuery = function (queryBuilder) {
        var _this = this;
        if (typeof (queryBuilder.context) === "undefined") {
            queryBuilder.context = {};
        }
        Object.keys(this.options.userContext).map(function (key) {
            return {
                key: key,
                value: _this.options.userContext[key]
            };
        }).filter(function (pair) {
            return pair.value !== "";
        }).forEach(function (pair) {
            queryBuilder.context[pair.key] = pair.value;
        });
    };
    CoveoForSitecoreBase.prototype.getOptionsWithTabExternalContent = function (currentTabId) {
        var filterExpressionOptions = _.extend({}, this.options);
        if (typeof (currentTabId) !== "undefined" && this.options.hasOwnProperty(currentTabId)) {
            var tabOptions = this.options[currentTabId];
            filterExpressionOptions.externalSourcesFromCurrentTab = tabOptions.externalSources;
            filterExpressionOptions.externalCollectionsFromCurrentTab = tabOptions.externalCollections;
        }
        return filterExpressionOptions;
    };
    CoveoForSitecoreBase.prototype.generatePopulateOmniboxFunction = function (options) {
        var _this = this;
        var queryController = Coveo.get(this.element).queryController;
        return function (e, populateOmniboxObject) {
            _this.omniboxResultListHandler.populateOmniboxResultList(populateOmniboxObject, options, queryController);
        };
    };
    CoveoForSitecoreBase.prototype.getDomElementsMatchingSelector = function (querySelector) {
        // Using .map to pass from NodeListOf<Element> to Array<Element> type. Can't do a direct cast.
        return _.map(document.querySelectorAll(querySelector), function (element) {
            return Coveo.$$(element);
        });
    };
    return CoveoForSitecoreBase;
}());
exports.__esModule = true;
exports["default"] = CoveoForSitecoreBase;



//////////////////
// WEBPACK FOOTER
// ./Base/CoveoForSitecoreBase.ts
// module id = 4
// module chunks = 0